import type { Reference } from '@medplum/fhirtypes'
import { invariant } from '#src/invariant.ts'

// Knock doesn't support the '/' character in user ids, so we replace it with ':'
export function toKnockId(reference: Reference): string {
  invariant(reference.reference, 'Reference must have a reference')
  return reference.reference.replace(/\//g, ':')
}
